import {NgModule} from '@angular/core';
import {AsModule} from "./as/as.module";
import {ChModule} from "./ch/ch.module";
import {EuModule} from "./eu/eu.module";
import {PcModule} from "./pc/pc.module";
import {PmModule} from "./pm/pm.module";
import {CmModule} from "./cm/cm.module";
import {FeatureCrmRoutingModule} from "./feature-crm.routing.module";
import {CaModule} from "./ca/ca.module";
import {CiModule} from "./ci/ci.module";
import {LmModule} from "./lm/lm.module";
import {OlModule} from "./ol/ol.module";
import {OmModule} from "./om/om.module";
import {SmModule} from "./sm/sm.module";
import {CtModule} from "./ct/ct.module";
import {CwModule} from "./cw/cw.module";
import {PdModule} from "./pd/pd.module";
import {VsModule} from "./vs/vs.module";

@NgModule({
    exports: [
        AsModule,
        ChModule,
        CmModule,
        CtModule,
        CwModule,
        EuModule,
        PcModule,
        PdModule,
        PmModule,
        CaModule,
        CiModule,
        LmModule,
        OlModule,
        OmModule,
        SmModule,
        VsModule,
    ],
    imports: [
        AsModule,
        ChModule,
        CmModule,
        CtModule,
        CwModule,
        EuModule,
        PcModule,
        PdModule,
        PmModule,
        CaModule,
        CiModule,
        LmModule,
        OlModule,
        OmModule,
        SmModule,
        VsModule,
        FeatureCrmRoutingModule
    ]
})
export class FeatureCrmModule {
}